<template>
  <div>
    <ElasticList
      :list.sync="taskList"
      :filter="filter"
      ref="tasklistRef"
    />
  </div>
</template>
<script>
import Record from '@/mixins/Record';
import { API, graphqlOperation } from "aws-amplify";
import * as queries_custom from '@/graphql/queries_custom';

export default {
  name: "tasktab",
  mixins: [Record],
  props: {
    routeParamsId: {
      type: String,
      required: true
    },
    taskListData: {
      type: Object,
      required: true
    },
    filter: {
      type: [Object, Array],
      required: false
    }
  },
  data() {
    return {
      taskList: {
          hideNewRecordButton: true,
          refreshData: false,
          linkRows: true,
          redirectNested: {
            parentPath: "cases",
            parentPathId: "case.id",
            path: "#/tasks", 
            requiredObj: 'task'           
          },          
          itemActions: [
            {
              class: "md-just-icon md-warning md-simple",
              icon: "description",
              click: "handleRedirectNested"
            },
            {
              class: "md-just-icon md-danger md-simple",
              icon: "close",
              click: "handleDelete"
            }
          ],
          editPath: "tasks",
          pageTitle: "Tasks",
          listQueryId: this.taskListData.listQueryId,
          responseFieldName: this.taskListData.responseFieldName,
          listQueryTarget: this.taskListData.listQueryTarget,
          deleteQueryId: this.taskListData.deleteQueryId,
          deleteQueryId: this.taskListData.deleteQueryId,
          deleteQueryIdField: "relateRecordId",
          // deleteMessageTitle: "Are you sure you want to remove {objectName} ?",
          // deleteMessageText: "",
          deleteMessageNameFieldsIsInESData: true,
          deleteMessageNameFields: ['task.subject'],
          
          // ATLAS-963: <Service/Account> <Task Tab> Column Changes
          // Added condition for showing case and assginee is list
          
          columns: this.taskListData.isShowCaseAndAssingeeInList 
            ? {
              "esData.task.subject": {
                label: "Subject",
                sortable: false,
                esSort: true,
                esKeyword: true,
                esNested: true,
              },
              "esData.task.status": {
                label: "Status",
                sortable: false,
                esSort: true,
                esKeyword: true,
                esNested: true,
              },
              "esData.task.case.subject": {
                label: "Case",
                sortable: false,
                esSort: true,
                esKeyword: true,
                esNested: true,
              },
              "esData.task.user": {
                label: "Assignee",
                sortable: false,
                esSort: true,
                esKeyword: true,
                searchable: true,
                display: true,
                esNested: true,
                nested: ["given_name", "family_name"],
              },
              "esData.task.createdAt": {
                label: "Created",
                sortable: true,
                esSort: true,
                esKeyword: false,
                esNested: true,
                dateFilter: true,
              },
            } : {
              "esData.task.subject": {
                label: "Subject",
                sortable: false,
                esSort: true,
                esKeyword: true,
                esNested: true,
              },
              "esData.task.status": {
                label: "Status",
                sortable: false,
                esSort: true,
                esKeyword: true,
                esNested: true,
              },
              "esData.task.createdAt": {
                label: "Created",
                sortable: true,
                esSort: true,
                esKeyword: false,
                esNested: true,
                dateFilter: true,
              },
            },
          linkConfigs: [
            {
              name: 'case',
              hrefCallback: (column, name, item) => {
                return '#/cases/' + (item.case && item.case.id ? item.case.id : "" );
              },
              titleCallback: (column, name, item) => {
                return item.case && item.case.subject ? item.case.subject : "";
              },
            },
            {
              name: 'user',
              hrefCallback: (column, name, item) => {
                return '#/users/' + (item.user && item.user.id ? item.user.id : "" );
              },
              titleCallback: (column, name, item) => {
                const assignee = item.user && item.user.given_name && item.user.family_name ? `${item.user.given_name} ${item.user.family_name}` : "";
                return assignee; 
              },
            }
          ],
          
          columnFilter: {
            showFilter: true,
            columnName: 'Status',
            columnFilterList: [],
            sourceData: [],
            selectedColumnItems: this.taskListData && this.taskListData.defaultStatus ? this.taskListData.defaultStatus : "",
            filterListQueryId: 'getListTaskStatusEnum',
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          tableData: [],
          searchedData: [],
          fuseSearch: null,
          formatResponse: (data) => {
            let result = [];
            if (!this.$Session.isAdminGroupMember) {
              if (this.taskList.linkConfigs && this.taskList.linkConfigs.length)
                this.taskList.linkConfigs = this.taskList.linkConfigs.filter(link => link.name !== "user");
            }

            let taskDataKey = this.taskListData.listQueryTarget ? this.taskListData.listQueryTarget : this.taskListData.listQueryId;
            if (data && data[taskDataKey] && data[taskDataKey].items && data[taskDataKey].items.length) {
              this.$c.log('formatResponse data', data[taskDataKey].items);
              data[taskDataKey].items.forEach((item) => {                
                if(this.taskListData && this.taskListData.directRecord){
                  item.relateRecordId = item.id;
                  result.push(item);
                }else{
                  item.relateRecordId = item.id;
                  item.id = item.task.id;
                  result.push(item);
                }                
              })
            }
            
            /**
             * If case IDs were passed in list config then filter out those
             * results which belong to the specified case ids
             */
            /** As account associated to task considering the task-case itself, we can skip this filter. 
             */

            // const caseIds = this.$reduce(this, 'taskListData.caseIds');
            // if (caseIds && caseIds.length) {
            //   result = result.filter(_task => {
            //     const taskCaseId = this.$reduce(_task, 'case.id');
            //     return taskCaseId && -1 != caseIds.indexOf(taskCaseId);
            //   });
            // }

            // Filtering task list based on selected status
            // if (this.taskList.columnFilter && this.taskList.columnFilter.selectedColumnItems) {
            //   result = result.filter(item => item.status && item.status.replace(/_/g, " ")  === this.taskList.columnFilter.selectedColumnItems);
            // } 
            return result;
          },
        },
        subscriptions: {
          onCreateTaskService: {
              result: null,
              load: true,
              function: (eventData) => {
                  this.$c.log('SUBSCRIPTION Trigger: onCreateTaskService');
                  if (eventData.value.data.onCreateTaskService.service.id === this.$route.params.id) 
                  {
                    this.$refs.tasklistRef.refresh();
                  }
              }
          },
          onUpdateTaskService: {
              result: null,
              load: true,
              function: (eventData) => {
                  this.$c.log('SUBSCRIPTION Trigger: onUpdateTaskService');
                  if (eventData.value.data.onUpdateTaskService.service.id === this.$route.params.id) 
                  {
                    this.$refs.tasklistRef.refresh();
                  }
              }
          },
          onDeleteTaskService: {
              result: null,
              load: true,
              function: (eventData) => {
                  this.$c.log('SUBSCRIPTION Trigger: onDeleteTaskService');
                  if (eventData.value.data.onDeleteTaskService.service.id === this.$route.params.id) 
                  {
                    this.$refs.tasklistRef.refresh();
                  }
              }
          },
      },
    };
  },
  methods: {
      async getColumnFilterList () {
          let params = {}, operation;
          operation = graphqlOperation(queries_custom[this.taskList.columnFilter.filterListQueryId], params);
          const result = await API.graphql(operation);
          result.data.listTaskStatusEnum.enumValues.forEach((item) => {
            let filterName = item.name.replace(/_/g, ' ');
            let filterColumnItems = {'label': filterName, 'value': filterName};
            this.taskList.columnFilter.columnFilterList.push(filterColumnItems);
          })
      },
  },
  mounted () { 
    this.getColumnFilterList();
  }
};
</script>

<style lang="scss">

</style>